<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text>
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <h4 class="font-weight-bold">{{ $t('book/facility:facility.event-log-dialog.title')}}</h4>

              <v-text-field
                  v-model="eventLog.text1"
                  clearable
                  outlined
                  :label="$t('book/facility:common.text')"
                  tabindex="60"/>

              <v-select
                  v-model="eventLog.eventLogType"
                  :items="itemsEventLogType"
                  item-value="value"
                  item-text="text"
                  :label="$t('book/facility:facility.event-log-dialog.event-log-type')"
                  outlined
                  :menu-props="{ bottom: true, offsetY: true }"
                  tabindex="61"
              />

              <BaseButton
                  color="primary"
                  :btnText="$t('buttons:add')"
                  @clickedButton="saveEventLog"
              />

              <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:cancel')"
                  color="grey"
                  :dialog-title="$t('dialog:dirty-save-btn-title')"
                  :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="closeDialog"
                  :dataToWatch="eventLog"
                  hideOverlay
              />
            </v-col>
            <v-col class="d-none d-md-block" md="5"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

import UsersService from "@/modules/core/services/users-service";
import EventLogService from "@/modules/book/services/eventlog-service";

import Utils from "@/modules/core/services/utils";
import DataUtils from "@/modules/core/services/data-utils";

import Users from "@/modules/core/data/users";
import EventLog from "@/modules/book/data/eventlog";

import BaseButton from "@/modules/core/components/Base/BaseButton";
import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";

export default {
  name: 'FacilityEventLogDialogForm',
  components: {
    BaseButton,
    DirtyConfirmButtonDialog
  },
  computed: {
    itemsEventLogType() {
      return [
        {'text' : this.$t('common:user'), 'value' : 'USER'},//Role,}
        {'text' : this.$t('common:process'), 'value' : 'PROCESS'},//Process, Job Service
        {'text' : this.$t('common:document'), 'value' : 'DOCUMENT'},
        {'text' : this.$t('common:facility'), 'value' : 'FACILITY'}
      ]
    },
    currentLang() {
      return this.$store.state.translation.language;
    }
  },
  data() {
    return {
      eventLog: new EventLog(),
      dialog: false,
      loggedUser : null,
      logData: {
        category: null,
        options: null
      }
    }
  },
  methods: {
    // closes and resets card fields and form
    closeDialog() {
      this.dialog = false;
      this.$refs.form.reset();
    },

    openDialog(options, category) {
      this.logData.category = category;
      this.logData.options = options;

      this.dialog = true;
    },

    async saveEventLog () {
      const newEventLog = {
        facilityId : this.$route.params.id,
        eventLogEvent : 'EDITED_BY_USER',
        eventLogType : this.eventLog.eventLogType,
        text1 : this.eventLog.text1,
        text2 : this.loggedUser.username,
        text3: "",
        referenceId : ""
      };

      EventLogService.postEventLog(newEventLog,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('book/facility:facility.snackbar:eventLog')}))
          this.closeDialog();
          this.$emit('updateEventLogs', this.logData.options, this.logData.category)
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('book/facility:facility.snackbar:eventLog')}))
          this.$logger.error('Failed to load EventLogs: ' + error)
        }
      )
    }
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      });
    },
    dialog() {
      if(this.dialog) {
        UsersService.readProfileFromAPI(
          (resp) => {
            var response = DataUtils.parseDataToSingleObject(resp.data, Users);
            if (response == null) {
              this.$logger.error("Failed to receive user data!");
            } else {
              this.loggedUser = response;
              this.eventLog = new EventLog();
              this.$refs.dirtyDialog.startWatch();
            }
          },
          (error) => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/event:log.snackbar.user')}))
            this.$logger.error(error);
          }
        )
      }
    }
  }
}
</script>